import { Component, OnInit } from '@angular/core';
import { GroupTicketService } from '../Services/groupTicket.service';
import { BookingListProperties } from '../Models/BookingListProperties';
import { Router } from '@angular/router';
import { OfflineToOnlineProperties, TicketPnrRights } from '../Models/TicketIssuanceProperties';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';

@Component({
  selector: 'app-groupTicketList',
  templateUrl: './groupTicketList.component.html',
  styleUrls: ['./groupTicketList.component.css']
})
export class GroupTicketListComponent implements OnInit {
  groupTicketRequestList: BookingListProperties[] | undefined;
  tktPnrRight = new TicketPnrRights();
  offlinetoOnline = new OfflineToOnlineProperties();
  constructor(private groupTicketSerive: GroupTicketService, private router: Router, private ticketIssuanceService: TicketIssuanceService) { }

  ngOnInit(): void {
    this.Loadrights();
    this.groupTicketSerive.GetGroupTicketIssueRequestList().subscribe(data => {
      this.groupTicketRequestList = data.map(tkt => {
        return { ...tkt, bookingDate: tkt.bookingDate.split("T")[0], travelDate: tkt.travelDate.split("T")[0] }
      });
    })
  }
  Loadrights=():void=> {
    this.ticketIssuanceService.CheckTktPnrRightsAgainstAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((response) => {
      this.tktPnrRight = response;
    })
  }
  ManageGroupTicket = (data: any): void => {
    try {
      if (data.requestTypeName == "Online Ticket Request") {
        if (this.tktPnrRight.issueTicket) {
          localStorage.setItem("bookingID", data.bookingID);
          this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
          this.offlinetoOnline.AgencyTicketReqFromOffline = data.agencyId.split("-")[0];
          this.offlinetoOnline.TicketIssueReqFromOffline = true;
          localStorage.setItem("fromroutePageNoright", "GroupTicketList");
          localStorage.setItem("OffilineRequest", "True");
          this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
          localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));

          this.router.navigateByUrl('/ticket-issuance');
        }
        else {
          localStorage.setItem("bookingID", data.bookingID);
          localStorage.setItem("OffilineRequest", "False");
          this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
          this.offlinetoOnline.AgencyTicketReqFromOffline = data.agencyId.split("-")[0];
          this.offlinetoOnline.TicketIssueReqFromOffline = true;
          localStorage.setItem("fromroutePageNoright", "GroupTicketList");
          this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
          localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));

          this.router.navigateByUrl('/ticket-issuance');
        }
      }
       else if (data.requestTypeName == "Online PNR Cancel Request") {
        if (this.tktPnrRight.cancelPnr) {
          localStorage.setItem("bookingID",data.bookingID);
          localStorage.setItem("OffilineRequest", "True");
          this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
          this.offlinetoOnline.AgencyTicketReqFromOffline = data.agencyId.split("-")[0];
          this.offlinetoOnline.PNRReqFromOffline = true;
          localStorage.setItem("fromroutePageNoright", "GroupTicketList");
          this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
          localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
          this.router.navigateByUrl('/ticket-issuance');
        }
        else {
          localStorage.setItem("bookingID", data.bookingID);
          localStorage.setItem("OffilineRequest", "False");
          this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
          this.offlinetoOnline.AgencyTicketReqFromOffline = data.agencyId.split("-")[0];
          this.offlinetoOnline.PNRReqFromOffline = true;
          localStorage.setItem("fromroutePageNoright", "GroupTicketList");
          this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
          localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
          this.router.navigateByUrl('/ticket-issuance');
        }
      }

      // localStorage.setItem('bookingID', bookingID.toString());
      // this.router.navigateByUrl('/ticket-issuance');
    }
    catch (e) {
      console.log(e)
     }
  }

}
